import {BaseModel} from "../../../../../infrastructure/models/base-model";
import {PredictionDetailsPopup} from "../../../../../core/components/prediction/models/assets/prediction-details-popup";

export class PredictionContextModel extends BaseModel {
  get hasIcon(): Boolean {
    return true;
  }

  get iconSource(): Boolean {
    return new PredictionDetailsPopup(16,16);
  }
}
